import * as Sentry from "@sentry/react";
import { SUBSCRIPTION_PLANS_URL } from "../constants/endpoints";
import axiosClient from "./axios";
import type { PlanStatus } from "../types/subscriptionPlans";

class FetchSubscriptionPlansService {
  static async fetchSubscriptionPlans(
    page: number,
    limit: number,
    status?: PlanStatus | null
  ) {
    const params: Record<string, unknown> = { page, limit };
    // "all" is expressed by omitting the filter rather than sending a value.
    if (status) params.status = status;

    return Sentry.startSpan(
      {
        op: "http.client",
        name: "GET /admin/chargeAtWill/plans",
      },
      async () => {
        return axiosClient.get(SUBSCRIPTION_PLANS_URL, { params });
      }
    );
  }
}

export default FetchSubscriptionPlansService;
